import { AsyncStorageKeyEnum } from '../constants/enums/index.enum';

class StorageService {
  // Set a value in AsyncStorage
  static setData<T>(key: AsyncStorageKeyEnum, value: T): void {
    try {
      const jsonValue = JSON.stringify(value);
      window.localStorage.setItem(key, jsonValue);
    } catch (e) {
      console.error('Error saving data', e);
    }
  }

  // Get a value from AsyncStorage
  static getData<T>(key: AsyncStorageKeyEnum): T | null {
    try {
      const jsonValue = window.localStorage.getItem(key);
      return jsonValue != null ? JSON.parse(jsonValue) : null;
    } catch (e) {
      console.error('Error fetching data', e);
      return null;
    }
  }

  // Remove a value from AsyncStorage
  static removeData(key: AsyncStorageKeyEnum): void {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      console.error('Error removing data', e);
    }
  }

  // Clear all values in AsyncStorage
  static clearAllData(): void {
    try {
      window?.localStorage?.clear();
    } catch (e) {
      console.error('Error clearing all data', e);
    }
  }
}

export default StorageService;
